module.exports = __webpack_public_path__ + "static/keedon-595f2ef5a14dc28225bfbf89c55bb071.png";